import React, {useEffect} from 'react'
import withView from '../../cmn/docAutomation/withView';
import SarasAllRowSelector from "../../../library/hooks/selector/SarasAllRowSelector";
import SarasTrans from '../../../library/notifications/SarasTrans'
import FormButton from '../../../library/form/components/FormActionButton2';
import FormTitle from '../../../library/form/components/FormTitle'
import FormDialog from '../../../library/form/components/FormDialog';
import FormLabel from '../../../library/form/components/FormLabel';
import FormInput from '../../../library/form/components/FormInput';
import useRowSelector from "../../../library/hooks/selector/useRowSelector";
import FormWrapper from '../../../library/form/components/FormWrapper';

import InvImportItems from './InvImportItems'
import InvTrnHeaderSH1 from './InvTrnHeaderSH1';

const InvImportItemsHeader = (props) => {
    const { formObject, viewData, ...restProps } = props;

    const rowSelector = useRowSelector("2", null);

    const initialiseRowSelection = () => {
        const rowIds = viewData ? Object.values(viewData).map(row => row.rowKey) : [];
        const preSelectAllData = formObject.getFormData("", "importHeader", "preSelectAll");
        const preSelectAll = formObject.getValueFromKey(preSelectAllData, "val", "0");

        if (rowIds.length === 0) {
            rowSelector.setSelectedRowsList([], false);
            return;
        }

        if (preSelectAll !== "1") {
            return;
        }

        rowSelector.setSelectedRowsList(rowIds, true);
    };

    useEffect(initialiseRowSelection, [viewData]);

    if (!viewData)
        return (null)

    const fromDocData = formObject.getFormData("", "importHeader", "fromDocId");
    const toDocData = formObject.getFormData("", "importHeader", "toDocId");

    const shOption = formObject.getFormData("", "importHeader", "shOption").val;
    const showMode = formObject.getFormData("", "importHeader", "showMode").val;
    
    const imdtId = formObject.getValueFromKey(fromDocData, "dataList.valLDT");
    const imdocId = formObject.getValueFromKey(fromDocData, "val");
    const tdtId = formObject.getValueFromKey(toDocData, "dataList.valLDT");
    const tdId = formObject.getValueFromKey(toDocData, "val");
    const tdws = formObject.getValueFromKey(toDocData, "dataList.tdws");

    // console.log("import item", viewData, imdtId, imdocId, tdtId, tdId, tdws);

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            headerKey="importHeader" rowKey="" attachData={1}
            action={{ actionId:"import", refreshMode:"dep",
            formActions: { forAction: "Confirm", forCancel: "Cancel" }, 
                            actionParam:{is:2, viewCaller: "importDoc", 
                                selected:rowSelector.getSelectedRowsCS(),
                                imdtId:imdtId,
                                imdocId:imdocId,
                                tdtId:tdtId,
                                tdId:tdId,
                                tdws:tdws,
                                showModeID:showMode, shOption: shOption,
                            }
                    }}
            formStyle={{ width: '850px' }}
            contentStyle={{ height: '400px' }}
            formTitle={<FormTitle formObject={formObject} value='' />}
            formObject={formObject} >
        <div className="uiImportWorkspace">
            <div className="uiImportWorkspaceLeft">
                <div className="uiImportCard uiImportRouteCard">
                    <div className="uiImportItemsHeaderForm">
                        <div className="uiImportItemsHeaderRow uiFlexDistributed">
                            <span className="uiLbl">
                                <SarasTrans value="From" /> <FormLabel format="#" formObject={formObject} headerKey="importHeader" action={{ paramName: "fromDocId" }} className='uiVal' />
                            </span>
                            <div className="uiImportItemsHeaderControls uiFlexBox">
                                <FormInput formObject={formObject} headerKey="importHeader" className=""
                                    action={{ InputType: "input", paramName: "fromDocId" }}
                                />
                                <FormButton formObject={formObject} headerKey="importHeader" className="uiActionButton"
                                    action={{ actionId: "import",  paramName: "getItem",
                                    actionParam: {
                                        imdtId:"#fromDocId.dataList.valLDT", 
                                        imdocId:"#fromDocId",
                                        tdtId:tdtId,
                                        tdId:tdId,
                                        tdws:tdws,
                                        is:1, 
                                        viewCaller:"importDoc", mode:"full"
                                    } }}
                                    text={<SarasTrans value="Get Items" />}>
                                </FormButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="uiImportCard uiImportItemsCard">
                    <div className='uiImportCardTitle'>
                        <SarasAllRowSelector rowSelector={rowSelector} customWrapper="span" className="uiRowAllSelector" wrapperClass="uiCheckRowSelector uiSpacerH5"/>
                        <SarasTrans value="Select All Items" />
                    </div>
                    <div className="uiImportItemsCardBody">
                        <InvImportItems formObject={formObject} viewData={viewData} rowSelector={rowSelector} />
                    </div>
                </div>
            </div>
            <FormWrapper customWrapper="div" 
                wrapperClass="uiImportCard uiImportWorkspaceRight uiImportDetailsCard" formObject={formObject} 
                headerKey="importHeader" action={{ paramName: "headerViewContainer" }} >
                <div className='uiImportCardTitle'>
                    <FormLabel format="#" formObject={formObject} headerKey="importHeader" action={{ paramName: "toDocId" }} className='uiVal' /> <SarasTrans value="Details" />
                </div>
                <InvTrnHeaderSH1 formObject={formObject} headerKey="importHeader" />
            </FormWrapper>
        </div>
        </FormDialog>

    )
}

export default withView(InvImportItemsHeader, "invcomp", "invTrnHeader,itemDetail,invTrnFooter,invTrans,costbreakup,ccbreakup,qcSamplingList")
